import React from 'react';
import { ArrowBack } from '@mui/icons-material';
import { Button } from '@mui/material';
import { colors } from '../constants/globalcss';
import { sizes } from '../styles/commonStyles';

interface BackButtonProps {
  onClick: () => void;
  text?: string;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  text = 'Back',
  className,
}) => (
  <Button
    onClick={onClick}
    className={className}
    variant="outlined"
    startIcon={<ArrowBack />}
    sx={{
      '&:hover': {
        backgroundColor: colors.primary,
        color: colors.background.paper,
      },
      borderColor: colors.primary,
      borderRadius: sizes.borderRadius.medium,
      color: colors.primary,
      fontWeight: sizes.fontWeight.semiBold,
      letterSpacing: sizes.letterSpacing.wide,
      minWidth: '90px',
      padding: `${sizes.spacing.md} ${sizes.spacing.lg}`,
      textTransform: 'uppercase',
    }}
  >
    {text}
  </Button>
);

export default BackButton;
